/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
export const verifyOnlyLetters = (word: string) => {
  const value = word.replace(/[^a-zA-Z\s]/g, "");
  return value;
};

export const verifyLettersAndNumbers = (word: string) => {
  const value = word.replace(/[^a-zA-Z0-9]/g, "");
  return value;
};

export const verifyLanguageLetters = (word: string) => {
  const value = word.replace(/[^\p{L}\s]+/gu, "");
  return value;
};

export const verifyOnlyPositives = (value: number | string) => {
  const output = value.toString().replace(/[^0-9]/g, "");
  return output;
};

export const verifyOnlyNumbers = (word: string) => {
  // only allow numbers and remove spaces
  let value = word.replace(/[^0-9]/g, "");
  value = value.replace(" ", "");
  return value;
};

export const removeLeadingZeros = (value: string) => {
  let newValue = value;
  if (/^0{2,}$/.test(newValue)) {
    newValue = "0";
  } else if (newValue.length > 1) {
    newValue = newValue.replace(/^0+/, "");
  }

  return newValue;
};